import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class RoleService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/roles'
    });
  }
}

const service = new RoleService();

export default service;
